import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
    constructor(){}

    getUserSession():string{
        return sessionStorage.getItem('user')?.toString()?.replace(/['"]+/g, '');
    }
    getIdUserSession(): number{
      let idUser : string | null = sessionStorage.getItem('idUser');
      return idUser == null ? 0 : Number(idUser);
  }
}